<div id="content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>{{ page_title }}</h1>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <form class="card paginator filters-card" [formGroup]="filterForm">
          <mat-form-field appearance="outline" class="period-field">
            <mat-label>Periodo</mat-label>
            <mat-date-range-input [rangePicker]="periodPicker">
              <input matStartDate formControlName="from" placeholder="Inicio" />
              <input matEndDate formControlName="to" placeholder="Fin" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #periodPicker></mat-date-range-picker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Comerciales</mat-label>
            <mat-select formControlName="commercial_ids" multiple>
              @for (c of commercials; track c.id) {
                <mat-option [value]="c.id">{{ c.name }} {{ c.surnames }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Orígenes</mat-label>
            <mat-select formControlName="origin_ids" multiple>
              @for (origin of origins; track origin.id) {
                <mat-option [value]="origin.id">{{ origin.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>

    @if (summary) {
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Embudo setter</h2>
                <p class="subtitle">Triager / captación</p>
              </div>
            </div>
            <div class="row g-2">
              @for (row of setterRows; track row.key) {
                <div class="col-6">
                  <div class="metric-card-style">
                    <h5 class="metric-card-title">{{ row.label }}</h5>
                    <h2 class="metric-card-value">{{ summaryValue(row) }}</h2>
                  </div>
                </div>
              }
            </div>
            @if (summary.rejection_reasons?.length) {
              <div class="rejection-breakdown">
                <p class="subtitle rejection-title">Motivos de no calificación</p>
                @for (reason of summary.rejection_reasons; track reason.reason) {
                  <div class="rejection-row">
                    <div class="rejection-row-top">
                      <span>{{ reason.label }}</span>
                      <strong>{{ reason.count }} · {{ reason.percentage != null ? reason.percentage + '%' : '—' }}</strong>
                    </div>
                    <div class="rejection-bar">
                      <div class="rejection-bar-fill" [style.width.%]="reason.percentage ?? 0"></div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Embudo closer</h2>
                <p class="subtitle">Reuniones y cierre</p>
              </div>
            </div>
            <div class="row g-2">
              @for (row of closerRows; track row.key) {
                <div class="col-6">
                  <div class="metric-card-style">
                    <h5 class="metric-card-title">{{ row.label }}</h5>
                    <h2 class="metric-card-value">{{ summaryValue(row) }}</h2>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Ratios clave</h2>
                <p class="subtitle">Conversión del periodo</p>
              </div>
            </div>
            <div class="row g-2">
              @for (row of ratioRows; track row.key) {
                <div class="col-12">
                  <div class="metric-card-style metric-card-row">
                    <h5 class="metric-card-title mb-0">{{ row.label }}</h5>
                    <h2 class="metric-card-value mb-0">{{ summaryValue(row) }}</h2>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      @if (summary.leads_by_meta_ad?.length) {
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title">
                  <h2>Leads por anuncio Meta</h2>
                  <p class="subtitle">Total y distribución por estado actual</p>
                </div>
              </div>
              <div class="bisual-table">
                <div class="bisual-table-container">
                  <table class="matrix-table meta-ad-status-table">
                    <thead>
                      <tr>
                        <th class="sticky-col">Anuncio</th>
                        <th class="meta-ad-num">Total</th>
                        <th class="meta-ad-num">%</th>
                        @for (status of metaAdStatusColumns; track status.slug) {
                          <th class="status-column" [attr.data-status]="status.slug" [title]="status.label">
                            {{ shortStatusLabel(status.label) }}
                          </th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (ad of summary.leads_by_meta_ad; track (ad.ad_id ?? '') + '|' + ad.label) {
                        <tr>
                          <td
                            class="sticky-col"
                            [title]="
                              ad.ad_id ? ad.label + (ad.campaign_name ? ' · ' + ad.campaign_name : '') + ' (' + ad.ad_id + ')' : ad.label
                            "
                          >
                            <div class="meta-ad-cell">
                              <span class="meta-ad-name">{{ ad.label }}</span>
                              @if (ad.campaign_name) {
                                <span class="meta-ad-campaign">{{ ad.campaign_name }}</span>
                              }
                            </div>
                          </td>
                          <td class="meta-ad-num meta-ad-total">{{ ad.count }}</td>
                          <td class="meta-ad-num">{{ ad.percentage != null ? ad.percentage + '%' : '—' }}</td>
                          @for (status of ad.by_status ?? []; track status.slug) {
                            <td class="status-column" [attr.data-status]="status.slug" [class.is-empty]="status.count === 0">
                              {{ status.count || '—' }}
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    }

    @if (days.length) {
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Vista diaria</h2>
                <p class="subtitle">Métricas en filas · días en columnas</p>
              </div>
            </div>
            <div class="bisual-table">
              <div class="bisual-table-container matrix-scroll">
                <table class="matrix-table">
                  <thead>
                    <tr>
                      <th class="sticky-col">Métrica</th>
                      @for (day of days; track day.date) {
                        <th [class.today]="isToday(day.date)" [class.weekend]="isWeekend(day.date)">
                          <div class="day-head">
                            <span class="dow">{{ dayWeekday(day.date) }}</span>
                            <span class="dom">{{ dayLabel(day.date) }}</span>
                          </div>
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      group of [
                        { title: 'Setter', rows: setterRows },
                        { title: 'Closer', rows: closerRows },
                        { title: 'Ratios', rows: ratioRows },
                      ];
                      track group.title
                    ) {
                      <tr class="group-row">
                        <td class="sticky-col">{{ group.title }}</td>
                        @for (day of days; track day.date) {
                          <td></td>
                        }
                      </tr>
                      @for (row of group.rows; track row.key) {
                        <tr>
                          <td class="sticky-col">{{ row.label }}</td>
                          @for (day of days; track day.date) {
                            <td
                              [ngClass]="heatClass(row, day)"
                              [class.today]="isToday(day.date)"
                              [class.weekend]="isWeekend(day.date)"
                              [class.ratio-cell]="row.format !== 'number'"
                            >
                              {{ cellValue(row, day) }}
                            </td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
